import React, { useMemo } from 'react';
import Head from 'next/head';
import { getCardSuitePath } from '@zola/zola-ui/src/paper/cards/util/getCardUrl';
import getProductSchema from 'cards/pages/ProductDetail/helper';

type DataPerColor = {
  imgs: string[];
  colors: string[];
};

type Color = {
  plp_front_image_url: string;
  label: string;
};

type Product = {
  name: string;
  description: string;
  suiteUUID: string;
  min_price_cents: number;
  colors: Color[];
};

type SEOSchemaProps = {
  products: Product[];
  cardType: string;
  isDigital: boolean;
};

const SEOSchema = ({ products = [], cardType = '', isDigital }: SEOSchemaProps): JSX.Element => {
  const stringifiedContent = useMemo(() => {
    const getJsonProductSchema = products.map(product => {
      const itemPrice = (product?.min_price_cents / 100).toFixed(2);
      const itemDataPerColor = product?.colors.reduce(
        (acc: DataPerColor, color: Color) => {
          acc.imgs.push(color.plp_front_image_url);
          acc.colors.push(color.label);
          return acc;
        },
        { imgs: [], colors: [] }
      );

      return getProductSchema({
        itemName: product?.name,
        itemImgUrlPerColor: itemDataPerColor?.imgs,
        itemColors: itemDataPerColor?.colors,
        itemDescription: product?.description,
        itemSku: product?.suiteUUID,
        // @ts-expect-error cardType should be a CardType
        itemUrl: getCardSuitePath(cardType, product?.suiteUUID, false, isDigital),
        itemPrice,
      });
    });
    return JSON.stringify(getJsonProductSchema);
  }, [products, cardType, isDigital]);

  return (
    <Head>
      <script type="application/ld+json" key="cardPlpProductsSchema">
        {stringifiedContent}
      </script>
    </Head>
  );
};

export default SEOSchema;
